import React, { useContext, useState } from "react";
import Swal from "sweetalert2";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";

export default function MSbuttons({ project_id, expertIds }) {
  const { API_URL } = useContext(UrlContext);
  // const { checkAccessToken } = useContext(UserContext);
  const [pptDownloading, setPptDownloading] = useState(false);
  const [wordDownloading, setWordDownloading] = useState(false);
  const [filePath, setFilePath] = useState("");

  const createWordHandler = () => {
    setWordDownloading(true);
    const authToken = localStorage.getItem("accesstoken");
    const url = `${API_URL}create-full-word/`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ expertIds, project_id, authToken }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setFilePath(data.filePath);
          window.open(data.filePath, "_blank", "rel=noopener noreferrer");
          setWordDownloading(false);
        }
        if (data.status === "error") {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: data.message,
          });
          setWordDownloading(false);
        }
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: `${err.message}`,
        });
      });
  };
  const createPPTHandler = () => {
    setPptDownloading(true);
    const authToken = localStorage.getItem("accesstoken");
    const url = `${API_URL}create-full-ppt/`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ expertIds, project_id, authToken }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          window.open(data.filePath, "_blank", "rel=noopener noreferrer");
          setFilePath(data.filePath);
          setPptDownloading(false);
        }
        if (data.status === "error") {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Please select digital ppt created experts!",
          });
          setPptDownloading(false);
        }
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        setPptDownloading(false);
      });
  };

  return (
    <>
      <button className="btn-ms" onClick={createWordHandler}>
        <i className="fa-regular fa-file-word" /> Create Word
      </button>
      <button className="btn-ms" onClick={createPPTHandler}>
        <i className="fa-regular fa-file-powerpoint" /> Create PPTX
      </button>

      {pptDownloading && (
        <div className="linkedin-popup-wrapper">
          <div className="tab-pane fade show linkedin-div">
            <center>
              <p style={{ fontSize: "18px" }}>Downloading PPT . . .</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}

      {wordDownloading && (
        <div className="linkedin-popup-wrapper">
          <div className="tab-pane fade show linkedin-div">
            <center>
              <p style={{ fontSize: "18px" }}>Downloading Word . . .</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
    </>
  );
}
